// UI capabilities by role (Frontend §5.3): one file. They hide nav items and buttons; the server still decides
// (Architecture §6.1).
import { useMemo } from 'react'

export type Capability = 'users.manage'

export interface CapabilityContext {
  /** The role in the current clinic (from `/v1/me` memberships), or null. */
  role: 'admin' | 'user' | null
  /** A super admin impersonating this clinic acts as Clinic Admin (D-09). */
  impersonating?: boolean
}

const RULES: Record<Capability, (c: CapabilityContext) => boolean> = {
  'users.manage': (c) => c.impersonating === true || c.role === 'admin',
}

export function can(capability: Capability, context: CapabilityContext): boolean {
  return RULES[capability](context)
}

/** `useCan('users.manage', { role })`. */
export function useCan(capability: Capability, context: CapabilityContext): boolean {
  const { role, impersonating } = context
  return useMemo(() => can(capability, { role, impersonating }), [capability, role, impersonating])
}
